(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[24],{

/***/ "K9S6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = all;

var _createChainableTypeChecker = __webpack_require__("pvIh");

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function all() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;

    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(undefined, args);
      if (result != null) {
        error = result;
      }
    });

    return error;
  }

  return (0, _createChainableTypeChecker2.default)(allPropTypes);
}
module.exports = exports['default'];

/***/ }),

/***/ "QojX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__("zLVn");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types-extra/lib/all.js
var lib_all = __webpack_require__("K9S6");

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__("17x9");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Feedback.js





var propTypes = {
  /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */
  type: prop_types_default.a.string,

  /** Display feedback as a tooltip. */
  tooltip: prop_types_default.a.bool,
  as: prop_types_default.a.elementType
};
var Feedback = react_default.a.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      className = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'valid' : _ref$type,
      _ref$tooltip = _ref.tooltip,
      tooltip = _ref$tooltip === void 0 ? false : _ref$tooltip,
      props = Object(objectWithoutPropertiesLoose["a" /* default */])(_ref, ["as", "className", "type", "tooltip"]);

  return /*#__PURE__*/react_default.a.createElement(Component, Object(esm_extends["a" /* default */])({}, props, {
    ref: ref,
    className: classnames_default()(className, type + "-" + (tooltip ? 'tooltip' : 'feedback'))
  }));
});
Feedback.displayName = 'Feedback';
Feedback.propTypes = propTypes;
/* harmony default export */ var esm_Feedback = (Feedback);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormContext.js
 // TODO

var FormContext = react_default.a.createContext({
  controlId: undefined
});
/* harmony default export */ var esm_FormContext = (FormContext);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__("vUet");

// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormCheckInput.js






var FormCheckInput = react_default.a.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      bsPrefix = _ref.bsPrefix,
      bsCustomPrefix = _ref.bsCustomPrefix,
      className = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'checkbox' : _ref$type,
      _ref$isValid = _ref.isValid,
      isValid = _ref$isValid === void 0 ? false : _ref$isValid,
      _ref$isInvalid = _ref.isInvalid,
      isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid,
      isStatic = _ref.isStatic,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'input' : _ref$as,
      props = Object(objectWithoutPropertiesLoose["a" /* default */])(_ref, ["id", "bsPrefix", "bsCustomPrefix", "className", "type", "isValid", "isInvalid", "isStatic", "as"]);

  var _useContext = Object(react["useContext"])(esm_FormContext),
      controlId = _useContext.controlId,
      custom = _useContext.custom;

  var _ref2 = custom ? [bsCustomPrefix, 'custom-control-input'] : [bsPrefix, 'form-check-input'],
      prefix = _ref2[0],
      defaultPrefix = _ref2[1];

  bsPrefix = Object(ThemeProvider["a" /* useBootstrapPrefix */])(prefix, defaultPrefix);
  return /*#__PURE__*/react_default.a.createElement(Component, Object(esm_extends["a" /* default */])({}, props, {
    ref: ref,
    type: type,
    id: id || controlId,
    className: classnames_default()(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid', isStatic && 'position-static')
  }));
});
FormCheckInput.displayName = 'FormCheckInput';
/* harmony default export */ var esm_FormCheckInput = (FormCheckInput);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormCheckLabel.js






var FormCheckLabel = react_default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      bsCustomPrefix = _ref.bsCustomPrefix,
      className = _ref.className,
      htmlFor = _ref.htmlFor,
      props = Object(objectWithoutPropertiesLoose["a" /* default */])(_ref, ["bsPrefix", "bsCustomPrefix", "className", "htmlFor"]);

  var _useContext = Object(react["useContext"])(esm_FormContext),
      controlId = _useContext.controlId,
      custom = _useContext.custom;

  var _ref2 = custom ? [bsCustomPrefix, 'custom-control-label'] : [bsPrefix, 'form-check-label'],
      prefix = _ref2[0],
      defaultPrefix = _ref2[1];

  bsPrefix = Object(ThemeProvider["a" /* useBootstrapPrefix */])(prefix, defaultPrefix);
  return /*#__PURE__*/react_default.a.createElement("label", Object(esm_extends["a" /* default */])({}, props, {
    ref: ref,
    htmlFor: htmlFor || controlId,
    className: classnames_default()(className, bsPrefix)
  }));
});
FormCheckLabel.displayName = 'FormCheckLabel';
/* harmony default export */ var esm_FormCheckLabel = (FormCheckLabel);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormCheck.js










var FormCheck = react_default.a.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      bsPrefix = _ref.bsPrefix,
      bsCustomPrefix = _ref.bsCustomPrefix,
      _ref$inline = _ref.inline,
      inline = _ref$inline === void 0 ? false : _ref$inline,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$isValid = _ref.isValid,
      isValid = _ref$isValid === void 0 ? false : _ref$isValid,
      _ref$isInvalid = _ref.isInvalid,
      isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid,
      _ref$feedbackTooltip = _ref.feedbackTooltip,
      feedbackTooltip = _ref$feedbackTooltip === void 0 ? false : _ref$feedbackTooltip,
      feedback = _ref.feedback,
      className = _ref.className,
      style = _ref.style,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'checkbox' : _ref$type,
      label = _ref.label,
      children = _ref.children,
      propCustom = _ref.custom,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'input' : _ref$as,
      props = Object(objectWithoutPropertiesLoose["a" /* default */])(_ref, ["id", "bsPrefix", "bsCustomPrefix", "inline", "disabled", "isValid", "isInvalid", "feedbackTooltip", "feedback", "className", "style", "title", "type", "label", "children", "custom", "as"]);

  var custom = type === 'switch' ? true : propCustom;

  var _ref2 = custom ? [bsCustomPrefix, 'custom-control'] : [bsPrefix, 'form-check'],
      prefix = _ref2[0],
      defaultPrefix = _ref2[1];

  bsPrefix = Object(ThemeProvider["a" /* useBootstrapPrefix */])(prefix, defaultPrefix);

  var _useContext = Object(react["useContext"])(esm_FormContext),
      controlId = _useContext.controlId;

  var innerFormContext = Object(react["useMemo"])(function () {
    return {
      controlId: id || controlId,
      custom: custom
    };
  }, [controlId, custom, id]);
  var hasLabel = custom || label != null && label !== false && !children;
  var input = /*#__PURE__*/react_default.a.createElement(esm_FormCheckInput, Object(esm_extends["a" /* default */])({}, props, {
    type: type === 'switch' ? 'checkbox' : type,
    ref: ref,
    isValid: isValid,
    isInvalid: isInvalid,
    isStatic: !hasLabel,
    disabled: disabled,
    as: as
  }));
  return /*#__PURE__*/react_default.a.createElement(esm_FormContext.Provider, {
    value: innerFormContext
  }, /*#__PURE__*/react_default.a.createElement("div", {
    style: style,
    className: classnames_default()(className, bsPrefix, custom && "custom-" + type, inline && bsPrefix + "-inline")
  }, children || /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, input, hasLabel && /*#__PURE__*/react_default.a.createElement(esm_FormCheckLabel, {
    title: title
  }, label), (isValid || isInvalid) && /*#__PURE__*/react_default.a.createElement(esm_Feedback, {
    type: isValid ? 'valid' : 'invalid',
    tooltip: feedbackTooltip
  }, feedback))));
});
FormCheck.displayName = 'FormCheck';
FormCheck.Input = esm_FormCheckInput;
FormCheck.Label = esm_FormCheckLabel;
/* harmony default export */ var esm_FormCheck = (FormCheck);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormFileInput.js






var FormFileInput = react_default.a.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      bsPrefix = _ref.bsPrefix,
      bsCustomPrefix = _ref.bsCustomPrefix,
      className = _ref.className,
      isValid = _ref.isValid,
      isInvalid = _ref.isInvalid,
      lang = _ref.lang,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'input' : _ref$as,
      props = Object(objectWithoutPropertiesLoose["a" /* default */])(_ref, ["id", "bsPrefix", "bsCustomPrefix", "className", "isValid", "isInvalid", "lang", "as"]);

  var _useContext = Object(react["useContext"])(esm_FormContext),
      controlId = _useContext.controlId,
      custom = _useContext.custom;

  var type = 'file';

  var _ref2 = custom ? [bsCustomPrefix, 'custom-file-input'] : [bsPrefix, 'form-control-file'],
      prefix = _ref2[0],
      defaultPrefix = _ref2[1];

  bsPrefix = Object(ThemeProvider["a" /* useBootstrapPrefix */])(prefix, defaultPrefix);
  return /*#__PURE__*/react_default.a.createElement(Component, Object(esm_extends["a" /* default */])({}, props, {
    ref: ref,
    id: id || controlId,
    type: type,
    lang: lang,
    className: classnames_default()(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
  }));
});
FormFileInput.displayName = 'FormFileInput';
/* harmony default export */ var esm_FormFileInput = (FormFileInput);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormFileLabel.js






var FormFileLabel = react_default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      bsCustomPrefix = _ref.bsCustomPrefix,
      className = _ref.className,
      htmlFor = _ref.htmlFor,
      props = Object(objectWithoutPropertiesLoose["a" /* default */])(_ref, ["bsPrefix", "bsCustomPrefix", "className", "htmlFor"]);

  var _useContext = Object(react["useContext"])(esm_FormContext),
      controlId = _useContext.controlId,
      custom = _useContext.custom;

  var _ref2 = custom ? [bsCustomPrefix, 'custom-file-label'] : [bsPrefix, 'form-file-label'],
      prefix = _ref2[0],
      defaultPrefix = _ref2[1];

  bsPrefix = Object(ThemeProvider["a" /* useBootstrapPrefix */])(prefix, defaultPrefix);
  return /*#__PURE__*/react_default.a.createElement("label", Object(esm_extends["a" /* default */])({}, props, {
    ref: ref,
    htmlFor: htmlFor || controlId,
    className: classnames_default()(className, bsPrefix),
    "data-browse": props['data-browse']
  }));
});
FormFileLabel.displayName = 'FormFileLabel';
/* harmony default export */ var esm_FormFileLabel = (FormFileLabel);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormFile.js










var FormFile = react_default.a.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      bsPrefix = _ref.bsPrefix,
      bsCustomPrefix = _ref.bsCustomPrefix,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$isValid = _ref.isValid,
      isValid = _ref$isValid === void 0 ? false : _ref$isValid,
      _ref$isInvalid = _ref.isInvalid,
      isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid,
      _ref$feedbackTooltip = _ref.feedbackTooltip,
      feedbackTooltip = _ref$feedbackTooltip === void 0 ? false : _ref$feedbackTooltip,
      feedback = _ref.feedback,
      className = _ref.className,
      style = _ref.style,
      label = _ref.label,
      children = _ref.children,
      custom = _ref.custom,
      lang = _ref.lang,
      dataBrowse = _ref['data-browse'],
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      _ref$inputAs = _ref.inputAs,
      inputAs = _ref$inputAs === void 0 ? 'input' : _ref$inputAs,
      props = Object(objectWithoutPropertiesLoose["a" /* default */])(_ref, ["id", "bsPrefix", "bsCustomPrefix", "disabled", "isValid", "isInvalid", "feedbackTooltip", "feedback", "className", "style", "label", "children", "custom", "lang", "data-browse", "as", "inputAs"]);

  var _ref2 = custom ? [bsCustomPrefix, 'custom'] : [bsPrefix, 'form-file'],
      prefix = _ref2[0],
      defaultPrefix = _ref2[1];

  bsPrefix = Object(ThemeProvider["a" /* useBootstrapPrefix */])(prefix, defaultPrefix);
  var type = 'file';

  var _useContext = Object(react["useContext"])(esm_FormContext),
      controlId = _useContext.controlId;

  var innerFormContext = Object(react["useMemo"])(function () {
    return {
      controlId: id || controlId,
      custom: custom
    };
  }, [controlId, custom, id]);
  var hasLabel = label != null && label !== false && !children;
  var input = /*#__PURE__*/react_default.a.createElement(esm_FormFileInput, Object(esm_extends["a" /* default */])({}, props, {
    ref: ref,
    isValid: isValid,
    isInvalid: isInvalid,
    disabled: disabled,
    as: inputAs,
    lang: lang
  }));
  return /*#__PURE__*/react_default.a.createElement(esm_FormContext.Provider, {
    value: innerFormContext
  }, /*#__PURE__*/react_default.a.createElement(Component, {
    style: style,
    className: classnames_default()(className, bsPrefix, custom && "custom-" + type)
  }, children || /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, custom ? /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, input, hasLabel && /*#__PURE__*/react_default.a.createElement(esm_FormFileLabel, {
    "data-browse": dataBrowse
  }, label)) : /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, hasLabel && /*#__PURE__*/react_default.a.createElement(esm_FormFileLabel, null, label), input), (isValid || isInvalid) && /*#__PURE__*/react_default.a.createElement(esm_Feedback, {
    type: isValid ? 'valid' : 'invalid',
    tooltip: feedbackTooltip
  }, feedback))));
});
FormFile.displayName = 'FormFile';
FormFile.Input = esm_FormFileInput;
FormFile.Label = esm_FormFileLabel;
/* harmony default export */ var esm_FormFile = (FormFile);
// EXTERNAL MODULE: ./node_modules/warning/warning.js
var warning = __webpack_require__("2W6z");

// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormControl.js









var FormControl = react_default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      bsCustomPrefix = _ref.bsCustomPrefix,
      type = _ref.type,
      size = _ref.size,
      htmlSize = _ref.htmlSize,
      id = _ref.id,
      className = _ref.className,
      _ref$isValid = _ref.isValid,
      isValid = _ref$isValid === void 0 ? false : _ref$isValid,
      _ref$isInvalid = _ref.isInvalid,
      isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid,
      plaintext = _ref.plaintext,
      readOnly = _ref.readOnly,
      custom = _ref.custom,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'input' : _ref$as,
      props = Object(objectWithoutPropertiesLoose["a" /* default */])(_ref, ["bsPrefix", "bsCustomPrefix", "type", "size", "htmlSize", "id", "className", "isValid", "isInvalid", "plaintext", "readOnly", "custom", "as"]);

  var _useContext = Object(react["useContext"])(esm_FormContext),
      controlId = _useContext.controlId;

  var _ref2 = custom ? [bsCustomPrefix, 'custom'] : [bsPrefix, 'form-control'],
      prefix = _ref2[0],
      defaultPrefix = _ref2[1];

  bsPrefix = Object(ThemeProvider["a" /* useBootstrapPrefix */])(prefix, defaultPrefix);
  var classes;

  if (plaintext) {
    var _classes;

    classes = (_classes = {}, _classes[bsPrefix + "-plaintext"] = true, _classes);
  } else if (type === 'file') {
    var _classes2;

    classes = (_classes2 = {}, _classes2[bsPrefix + "-file"] = true, _classes2);
  } else if (type === 'range') {
    var _classes3;

    classes = (_classes3 = {}, _classes3[bsPrefix + "-range"] = true, _classes3);
  } else if (Component === 'select' && custom) {
    var _classes4;

    classes = (_classes4 = {}, _classes4[bsPrefix + "-select"] = true, _classes4[bsPrefix + "-select-" + size] = size, _classes4);
  } else {
    var _classes5;

    classes = (_classes5 = {}, _classes5[bsPrefix] = true, _classes5[bsPrefix + "-" + size] = size, _classes5);
  }

   false ? undefined : void 0;
  return /*#__PURE__*/react_default.a.createElement(Component, Object(esm_extends["a" /* default */])({}, props, {
    type: type,
    size: htmlSize,
    ref: ref,
    readOnly: readOnly,
    id: id || controlId,
    className: classnames_default()(className, classes, isValid && "is-valid", isInvalid && "is-invalid")
  }));
});
FormControl.displayName = 'FormControl';
/* harmony default export */ var esm_FormControl = (Object.assign(FormControl, {
  Feedback: esm_Feedback
}));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormGroup.js






var FormGroup = react_default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      children = _ref.children,
      controlId = _ref.controlId,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = Object(objectWithoutPropertiesLoose["a" /* default */])(_ref, ["bsPrefix", "className", "children", "controlId", "as"]);

  bsPrefix = Object(ThemeProvider["a" /* useBootstrapPrefix */])(bsPrefix, 'form-group');
  var context = Object(react["useMemo"])(function () {
    return {
      controlId: controlId
    };
  }, [controlId]);
  return /*#__PURE__*/react_default.a.createElement(esm_FormContext.Provider, {
    value: context
  }, /*#__PURE__*/react_default.a.createElement(Component, Object(esm_extends["a" /* default */])({}, props, {
    ref: ref,
    className: classnames_default()(className, bsPrefix)
  }), children));
});
FormGroup.displayName = 'FormGroup';
/* harmony default export */ var esm_FormGroup = (FormGroup);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Col.js





var DEVICE_SIZES = ['xl', 'lg', 'md', 'sm', 'xs'];
var Col = react_default.a.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = Object(objectWithoutPropertiesLoose["a" /* default */])(_ref, ["bsPrefix", "className", "as"]);

  var prefix = Object(ThemeProvider["a" /* useBootstrapPrefix */])(bsPrefix, 'col');
  var spans = [];
  var classes = [];
  DEVICE_SIZES.forEach(function (brkPoint) {
    var propValue = props[brkPoint];
    delete props[brkPoint];
    var span;
    var offset;
    var order;

    if (typeof propValue === 'object' && propValue != null) {
      var _propValue$span = propValue.span;
      span = _propValue$span === void 0 ? true : _propValue$span;
      offset = propValue.offset;
      order = propValue.order;
    } else {
      span = propValue;
    }

    var infix = brkPoint !== 'xs' ? "-" + brkPoint : '';
    if (span) spans.push(span === true ? "" + prefix + infix : "" + prefix + infix + "-" + span);
    if (order != null) classes.push("order" + infix + "-" + order);
    if (offset != null) classes.push("offset" + infix + "-" + offset);
  });

  if (!spans.length) {
    spans.push(prefix); // plain 'col'
  }

  return /*#__PURE__*/react_default.a.createElement(Component, Object(esm_extends["a" /* default */])({}, props, {
    ref: ref,
    className: classnames_default.a.apply(void 0, [className].concat(spans, classes))
  }));
});
Col.displayName = 'Col';
/* harmony default export */ var esm_Col = (Col);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormLabel.js








var defaultProps = {
  column: false,
  srOnly: false
};
var FormLabel = react_default.a.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'label' : _ref$as,
      bsPrefix = _ref.bsPrefix,
      column = _ref.column,
      srOnly = _ref.srOnly,
      className = _ref.className,
      htmlFor = _ref.htmlFor,
      props = Object(objectWithoutPropertiesLoose["a" /* default */])(_ref, ["as", "bsPrefix", "column", "srOnly", "className", "htmlFor"]);

  var _useContext = Object(react["useContext"])(esm_FormContext),
      controlId = _useContext.controlId;

  bsPrefix = Object(ThemeProvider["a" /* useBootstrapPrefix */])(bsPrefix, 'form-label');
  var columnClass = 'col-form-label';
  if (typeof column === 'string') columnClass = columnClass + " " + columnClass + "-" + column;
  var classes = classnames_default()(className, bsPrefix, srOnly && 'sr-only', column && columnClass);
   false ? undefined : void 0;
  htmlFor = htmlFor || controlId;
  if (column) return /*#__PURE__*/react_default.a.createElement(esm_Col, Object(esm_extends["a" /* default */])({
    as: "label",
    className: classes,
    htmlFor: htmlFor
  }, props));
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    react_default.a.createElement(Component, Object(esm_extends["a" /* default */])({
      ref: ref,
      className: classes,
      htmlFor: htmlFor
    }, props))
  );
});
FormLabel.displayName = 'FormLabel';
FormLabel.defaultProps = defaultProps;
/* harmony default export */ var esm_FormLabel = (FormLabel);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormText.js





var FormText = react_default.a.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'small' : _ref$as,
      muted = _ref.muted,
      props = Object(objectWithoutPropertiesLoose["a" /* default */])(_ref, ["bsPrefix", "className", "as", "muted"]);

  bsPrefix = Object(ThemeProvider["a" /* useBootstrapPrefix */])(bsPrefix, 'form-text');
  return /*#__PURE__*/react_default.a.createElement(Component, Object(esm_extends["a" /* default */])({}, props, {
    ref: ref,
    className: classnames_default()(className, bsPrefix, muted && 'text-muted')
  }));
});
FormText.displayName = 'FormText';
/* harmony default export */ var esm_FormText = (FormText);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Switch.js



var Switch = react_default.a.forwardRef(function (props, ref) {
  return /*#__PURE__*/react_default.a.createElement(esm_FormCheck, Object(esm_extends["a" /* default */])({}, props, {
    ref: ref,
    type: "switch"
  }));
});
Switch.displayName = 'Switch';
Switch.Input = esm_FormCheck.Input;
Switch.Label = esm_FormCheck.Label;
/* harmony default export */ var esm_Switch = (Switch);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__("YdCC");

// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Form.js













var FormRow = Object(createWithBsPrefix["a" /* default */])('form-row');
var Form_defaultProps = {
  inline: false
};
var FormImpl = react_default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      inline = _ref.inline,
      className = _ref.className,
      validated = _ref.validated,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'form' : _ref$as,
      props = Object(objectWithoutPropertiesLoose["a" /* default */])(_ref, ["bsPrefix", "inline", "className", "validated", "as"]);

  bsPrefix = Object(ThemeProvider["a" /* useBootstrapPrefix */])(bsPrefix, 'form');
  return /*#__PURE__*/react_default.a.createElement(Component, Object(esm_extends["a" /* default */])({}, props, {
    ref: ref,
    className: classnames_default()(className, validated && 'was-validated', inline && bsPrefix + "-inline")
  }));
});
FormImpl.displayName = 'Form';
FormImpl.defaultProps = Form_defaultProps;
FormImpl.Row = FormRow;
FormImpl.Group = esm_FormGroup;
FormImpl.Control = esm_FormControl;
FormImpl.Check = esm_FormCheck;
FormImpl.File = esm_FormFile;
FormImpl.Switch = esm_Switch;
FormImpl.Label = esm_FormLabel;
FormImpl.Text = esm_FormText;
/* harmony default export */ var Form = __webpack_exports__["a"] = (FormImpl);

/***/ }),

/***/ "Rs/t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export documentItemShape */
/* unused harmony export documentDraftShape */
/* unused harmony export documentShowShape */
/* unused harmony export versionShowShape */
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("17x9");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

var ownerShape = prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.shape({
  id: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number.isRequired,
  avatar: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  username: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  first_name: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  last_name: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired
});
var workspaceShape = prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.shape({
  created_at: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  id: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number.isRequired,
  name: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  owner: ownerShape,
  path: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  updated_at: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired
});
var documentItemShape = prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.shape({
  content_update_count: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number.isRequired,
  content_updated_at: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  created_at: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  final_document_path: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  final_document_signature: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  id: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number.isRequired,
  open_to_public: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool.isRequired,
  owner: ownerShape,
  path: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  published: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool.isRequired,
  published_at: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  title: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  updated_at: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  workspace: workspaceShape
});
var documentDraftShape = prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.shape({
  block_spacing: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number,
  body: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  body_json: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired, prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.object.isRequired]),
  content_update_count: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number.isRequired,
  content_updated_at: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  created_at: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  final_document_path: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  frame_style: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  heading_family: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  heading_line_height: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number,
  id: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number.isRequired,
  open_to_public: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool.isRequired,
  owner: ownerShape,
  paragraph_color: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  paragraph_family: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  paragraph_line_height: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number,
  paragraph_size: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number,
  path: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  published: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool.isRequired,
  published_at: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  signature: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  template_name: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  theme: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  title: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  updated_at: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  workspace: workspaceShape
});
var documentShowShape = prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.shape({
  block_spacing: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number,
  body: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  body_json: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired, prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.object.isRequired]),
  content_update_count: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number.isRequired,
  content_updated_at: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  created_at: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  frame_style: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  heading_family: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  heading_line_height: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number,
  id: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number.isRequired,
  open_to_public: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool.isRequired,
  owner: ownerShape,
  paragraph_color: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  paragraph_family: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  paragraph_line_height: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number,
  paragraph_size: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number,
  path: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  published: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool.isRequired,
  published_at: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  signature: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  template_name: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  theme: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  title: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  updated_at: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  workspace: workspaceShape
});
var versionShowShape = prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.shape({
  block_spacing: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number,
  body: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  body_json: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired, prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.object.isRequired]),
  content_update_count: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number.isRequired,
  content_updated_at: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  created_at: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  frame_style: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  heading_family: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  heading_line_height: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number,
  id: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number.isRequired,
  open_to_public: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool.isRequired,
  owner: ownerShape,
  paragraph_color: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  paragraph_family: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  paragraph_line_height: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number,
  paragraph_size: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number,
  path: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  published: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool.isRequired,
  published_at: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  signature: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  template_name: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  theme: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  title: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  updated_at: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  version_created_at: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  workspace: workspaceShape
});

/***/ }),

/***/ "pvIh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),

/***/ "rePB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _defineProperty; });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ })

}]);